/** Loose shape so both i18next's TFunction and test stubs fit. */
export type TranslateFn = (key: string, options: Record<string, unknown>) => unknown;

/**
 * A time as a cook reads it on a clock: "45 min" / "1 h" / "1 h 30" / "1 h 05".
 * The minutes after an hour are padded, so 65 is never read as "1 h 5".
 */
export function formatDuration(minutes: number, t: TranslateFn): string {
  if (minutes < 60) {
    return String(
      t('recipeDetail.durationMinutes', { defaultValue: '{{count}} min', count: minutes })
    );
  }
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  const hoursLabel = String(
    t('recipeDetail.durationHours', { defaultValue: '{{count}} h', count: hours })
  );
  return rest > 0 ? `${hoursLabel} ${String(rest).padStart(2, '0')}` : hoursLabel;
}

export default formatDuration;
